
module dg.uiRouter {
    angular.module('dg.uiRouter', []);
}